module.exports = __webpack_public_path__ + "img/icone_fechar.4e97ddf8.svg";